import type { ConnectionBanner } from "../../api";

export function SessionRetry({
  issue,
  onRetry,
}: {
  issue: ConnectionBanner;
  onRetry: () => void;
}) {
  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 px-6">
      <div className="mapping-card" style={{ maxWidth: 480 }}>
        <h2 className="site-log-status-h3">{issue.title}</h2>
        <p className="muted">{issue.description}</p>
        {issue.technicalHint ? <p className="small muted">{issue.technicalHint}</p> : null}
        <button type="button" className="login-button" onClick={onRetry}>
          Retry
        </button>
      </div>
    </div>
  );
}
